import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";

export default function AgoraProvider({ children }) {
  const client = AgoraRTC.createClient({
    mode: "rtc",
    codec: "vp8",
    // Remove role: "host" to let React hooks manage role promotion
  });

  AgoraRTC.setLogLevel(4);
  return <AgoraRTCProvider client={client}>{children}</AgoraRTCProvider>;
}
